export default __webpack_public_path__ + "static/media/default_course-img.9ed779c6.svg";